<template>
  <v-main class="fill-height">
    <v-container fluid>
      <v-row class="align-center justify-center" style="min-height: 100vh">
        <v-col cols="auto">
          <v-card class="square-card d-flex flex-column align-center justify-center">
            <div class="text-body-1 font-weight-bold text-justify mx-3 my-2">
              <b>Por gentileza, aguarde enquanto verificamos suas informações.</b>
            </div>
            <div class="text-body-2 font-weight-light text-justify mx-3 my-2">
              Esse processo é automático e você será redirecionado para a solicitação de reembolso em alguns instantes.
            </div>
            <v-progress-circular color="primary" indeterminate :size="54" :width="7" class="mt-4"></v-progress-circular>

            <v-snackbar v-model="snackbar" :timeout="7000" color="red-lighten-4" elevation="24">
              {{ snackbarMessage }}
            </v-snackbar>
          </v-card>
        </v-col>
      </v-row>

      <v-dialog v-model="dialogTokenExpirado" max-width="500" persistent>
        <v-card class="pa-5 text-center">
          <v-card-text>
            <v-icon size="70" color="red">mdi-close-circle-outline</v-icon>
            <h3 class="mt-3 mb-2" style="color: #000000;">Token expirado</h3>
            O seu token de autenticação expirou. Por favor, feche esta página e tente novamente para obter um novo
            token.
            <small></small>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import axios from 'axios';

const props = defineProps(['token']);
const router = useRouter();
const route = useRoute(); // Para acessar os parâmetros da rota atual
const snackbar = ref(false);
const snackbarMessage = ref('');
const dialogTokenExpirado = ref(false);

onMounted(async () => {
  // Verifica se um CPF foi passado como parâmetro de consulta para mock
  if (route.query.cpf !== undefined) {
    console.log('MODO MOCK: Usando CPF da URL.');
    // Simula um atraso de rede
    setTimeout(() => {
      // Limpa qualquer token antigo para garantir que não seja enviado um token inválido
      localStorage.removeItem('auth_token_reembolso');

      // Usa o CPF da URL ou um CPF padrão se nenhum valor for fornecido
      const cpfToUse = route.query.cpf || '12345678900';
      localStorage.setItem('cpf_reembolso', cpfToUse);

      router.push('/');
    }, 1500);
  } else {
    // Fluxo real de validação de token
    console.log('MODO REAL: Validando token da URL.');
    let token = props.token;

    if (!token) {
      token = localStorage.getItem('auth_token_reembolso');
    }

    if (token && token !== localStorage.getItem('auth_token_reembolso')) {
      localStorage.setItem('auth_token_reembolso', token);
    }

    if (!token) {
      dialogTokenExpirado.value = true;
      return;
    }

    try {
      const response = await axios.get(`${process.env.VUE_APP_SOLICITACOES_API_URL}/auth/validate-token?_=${new Date().getTime()}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data?.cpf) {
        localStorage.setItem('cpf_reembolso', response.data.cpf);
        router.push('/');
      } else {
        dialogTokenExpirado.value = true;
      }
    } catch (error) {
      dialogTokenExpirado.value = true;
    }
  }
});
</script>

<style scoped>
.square-card {
  width: 100%;
  max-width: 400px;
  aspect-ratio: 1;
}

.my-5 {
  margin-top: 20px;
  margin-bottom: 20px;
}

.mx-3 {
  margin-left: 15px;
  margin-right: 15px;
}

.text-justify {
  text-align: justify;
}

.font-weight-light {
  font-weight: 300;
}

.fill-height {
  height: 100%;
}

.mt-4 {
  margin-top: 16px;
}
</style>
